module.exports = __webpack_public_path__ + "static/media/LidlPro_Regular.9c9c2e4d.woff2";